import { Typography } from '@mui/material';
import { useRef } from 'react';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import { ProjectPicker } from '@work4all/components/lib/components/entity-picker/project-picker/ProjectPicker';

import { Project } from '@work4all/models/lib/Classes/Project.entity';

import { PickerTargetButton } from './PickerTargetButton';

type Props = {
  disabled?: boolean;
  value: Project;
  onChange: (value: Project | null) => void;
};

export function ProjectPickerCell({ disabled, value, onChange }: Props) {
  const popoverRef = useRef<EntityPickerPopover>(null);

  return (
    <EntityPickerPopover
      ref={popoverRef}
      picker={
        <ProjectPicker value={value} onChange={onChange} multiple={false} />
      }
    >
      <PickerTargetButton disabled={disabled}>
        <Typography style={{ display: 'flex', alignItems: 'center' }}>
          {value?.name}
        </Typography>
      </PickerTargetButton>
    </EntityPickerPopover>
  );
}
